// extracted by mini-css-extract-plugin
export default {"root":"bNwuxwptxj","message":"t11htSuYsy","message_onImage":"pTiCutiIAI"};